module.exports = __webpack_public_path__ + "img/brand-lfv.a541d992.jpg";